module.exports = __webpack_public_path__ + "static/TimesLtPro-Italic-0183cd69490846eaebb46b9c6a93ee9f.woff2";